export const lineHeights = {
  s: '18px',
  m: '20px',
  l: '28px',
  '2l': '28px',
  xl: '40px',
  '2xl': '48px',
};
